module.exports = __webpack_public_path__ + "img/treatment-triangle-dark-mobile.36f31b94.svg";